import PermanentWalletButton from './PermanentWalletButton';
import usePermanentWalletButton from './usePermanentWalletButton';

export default PermanentWalletButton;
export { usePermanentWalletButton };
